import React, { useState } from 'react';
import { Box, TextField, Alert } from '@mui/material';
import UIButton from 'components/ui/UIButton';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { feedbackActions } from 'features/feedback/store/feedback.slice';
import RatingInput from 'features/feedback/components/RatingInput';

const ReviewForm: React.FC = () => {
  const dispatch = useAppDispatch();
  const formState = useAppSelector((s) => s.feedback.formState);
  const errorMessage = useAppSelector((s) => s.feedback.errorMessage);
  const submitting = formState === 'submitting';
  const [rating, setRating] = useState(0);
  const [description, setDescription] = useState('');
  const [touched, setTouched] = useState(false);
  const descErr = touched && !description.trim();

  const onSubmit = () => {
    setTouched(true);
    if (!description.trim()) return;
    dispatch(
      feedbackActions.submit({
        type: 'REVIEW', title: 'Відгук', description: description.trim(),
        rating: rating > 0 ? rating : undefined,
      }),
    );
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Alert icon={false} severity="info" sx={{ fontSize: 13 }}>🔒 Приватне — бачитимеш лише ти та адміністратор.</Alert>
      {formState === 'error' && <Alert severity="error">{errorMessage || 'Не вдалося надіслати. Спробуй ще раз.'}</Alert>}
      <Box sx={{ fontSize: 14, color: '#7A7F88' }}>Оцінка (необов&apos;язково)</Box>
      <RatingInput value={rating} onChange={setRating} />
      <TextField label="Твій відгук" value={description} onChange={(e) => setDescription(e.target.value)} error={descErr} helperText={descErr ? 'Напиши кілька слів' : ''} multiline minRows={4} fullWidth inputProps={{ maxLength: 5000 }} />
      <UIButton fullWidth variant="contained" disabled={submitting} onClick={onSubmit}>
        {submitting ? 'Надсилаємо…' : 'Надіслати'}
      </UIButton>
    </Box>
  );
};

export default ReviewForm;
